// import { showProcessSuccessMessage, showProcessErrorMessage } from "../../state/alertHelpers.js";
//
// import {getDomainSettings} from "@/services/modules/domain/domainService";

export const state = {
    apiBaseUrl: null,
}

export const mutations = {
}